let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gGDEq")).then(() => parcelRequire('1lRYl'));